import { Box, Typography } from '@mui/material';
import React from 'react';

const EmptyMessage = ({ message }) => {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      margin: 3
    }}>
      <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
        {message}
      </Typography>
    </Box>
  )
}

export default EmptyMessage